// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
mat-dialog-actions {
    justify-content: space-around;
}`, "",{"version":3,"sources":["webpack://./src/app/components/dashboard/modals/email-blocked-modal/email-blocked.component.css"],"names":[],"mappings":";AACA;IACI,6BAA6B;AACjC","sourcesContent":["\r\nmat-dialog-actions {\r\n    justify-content: space-around;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
